const productData = [
  {
    id: 1,
    name: "Moss Linen Journal",
    brand: "Hush Paper Studio",
    category: "Notebooks & Journals",
    price: 129,
    image: "/img/01-linen-journal.jpg",
    images: ["/img/01-linen-journal.jpg"],
    description:
      "A softly bound linen journal made for unhurried notes, collected thoughts and everyday sketches. The book opens flat and its warm-white paper handles both pencil and ink beautifully.",
    attributes: { Format: "A5", Pages: "192 dot-grid pages", Cover: "Book linen", Paper: "100 gsm" },
    tags: ["journal", "linen", "dot grid", "new"],
    size: ["A5"],
    colors: ["Moss", "Oat"],
    features: ["Thread-sewn lay-flat binding", "Two ribbon markers", "Acid-free warm-white paper"],
    rating: 4.9,
    reviews: 48,
    collection: "new",
    stock: 18,
  },
  {
    id: 2,
    name: "Quiet Grid Memo Pad",
    brand: "Hush Paper Studio",
    category: "Memos & Sticky Notes",
    price: 69,
    image: "/img/02-grid-memo.jpg",
    images: ["/img/02-grid-memo.jpg"],
    description:
      "A compact tear-off memo pad with a calm five-millimetre grid for lists, diagrams and tiny plans. The substantial paper keeps fountain-pen lines crisp.",
    attributes: { Size: "90 × 125 mm", Sheets: "80", Ruling: "5 mm grid", Paper: "90 gsm" },
    tags: ["memo", "grid", "desk", "new"],
    size: ["Small"],
    colors: ["Ivory"],
    features: ["Micro-perforated sheets", "Rigid recycled backboard", "Ink-friendly surface"],
    rating: 4.8,
    reviews: 31,
    collection: "new",
    stock: 32,
  },
  {
    id: 3,
    name: "Cloudline Index Tabs",
    brand: "Tocoro Atelier",
    category: "Memos & Sticky Notes",
    price: 45,
    image: "/img/03-cloud-sticky.jpg",
    images: ["/img/03-cloud-sticky.jpg"],
    description:
      "Translucent cloud-shaped index tabs that add a soft horizon to planners and reference books without covering the words beneath.",
    attributes: { Tabs: "120", Width: "12 mm", Material: "Translucent film", Adhesive: "Repositionable" },
    tags: ["tabs", "sticky notes", "pastel", "restock"],
    size: ["120 tabs"],
    colors: ["Morning Mix", "Dusk Mix"],
    features: ["Writable matte finish", "Removes cleanly", "Six gentle colours"],
    rating: 4.7,
    reviews: 64,
    collection: "restock",
    stock: 26,
  },
  {
    id: 4,
    name: "Garden Path Washi Trio",
    brand: "Nami Press",
    category: "Tapes & Stickers",
    price: 89,
    image: "/img/04-garden-washi.jpg",
    images: ["/img/04-garden-washi.jpg"],
    description:
      "Three original botanical washi tapes inspired by quiet garden paths: fine leaves, scattered seeds and a loose painterly check.",
    attributes: { Width: "15 mm", Length: "7 m each", Material: "Lightweight paper", Finish: "Matte" },
    tags: ["washi", "botanical", "journaling", "new"],
    size: ["Set of 3"],
    colors: ["Garden"],
    features: ["Tears neatly by hand", "Repositionable paper adhesive", "Original studio pattern"],
    rating: 4.9,
    reviews: 52,
    collection: "new",
    stock: 21,
  },
  {
    id: 5,
    name: "Sunset Washi Duo",
    brand: "Nami Press",
    category: "Tapes & Stickers",
    price: 65,
    compareAtPrice: 82,
    image: "/img/05-sunset-washi.jpg",
    images: ["/img/05-sunset-washi.jpg"],
    description:
      "A pair of softly graduated tapes moving from apricot to mauve, designed for layering into warm evening skies and gentle borders.",
    attributes: { Width: "15 & 20 mm", Length: "7 m each", Material: "Washi paper", Finish: "Matte gradient" },
    tags: ["washi", "gradient", "sale", "limited"],
    size: ["Set of 2"],
    colors: ["Sunset"],
    features: ["Semi-translucent colour", "Low-tack and repositionable", "Small seasonal edition"],
    rating: 4.8,
    reviews: 39,
    collection: "limited",
    stock: 9,
  },
  {
    id: 6,
    name: "Tea Table Sticker Sheet",
    brand: "Little Pause",
    category: "Tapes & Stickers",
    price: 45,
    image: "/img/06-tea-stickers.jpg",
    images: ["/img/06-tea-stickers.jpg"],
    description:
      "An original illustrated sticker sheet filled with tiny teacups, steam, biscuits and table linens for cozy journal spreads.",
    attributes: { Sheet: "100 × 150 mm", Pieces: "24", Material: "Uncoated paper", Finish: "Writable matte" },
    tags: ["stickers", "tea", "illustration", "new"],
    size: ["1 sheet"],
    colors: ["Warm Neutral"],
    features: ["Easy-peel kiss cut", "Writable surface", "Original non-character artwork"],
    rating: 4.6,
    reviews: 27,
    collection: "new",
    stock: 42,
  },
  {
    id: 7,
    name: "Meadow Press Sticker Flakes",
    brand: "Little Pause",
    category: "Tapes & Stickers",
    price: 59,
    image: "/img/07-meadow-stickers.jpg",
    images: ["/img/07-meadow-stickers.jpg"],
    description:
      "Delicate translucent sticker flakes with original meadow studies, made to look like small pressed finds tucked between journal pages.",
    attributes: { Pieces: "36", Designs: "12", Material: "Matte PET film", Pack: "Paper envelope" },
    tags: ["stickers", "flowers", "transparent", "restock"],
    size: ["36 flakes"],
    colors: ["Meadow"],
    features: ["Three of each design", "Layerable translucent edges", "Compact reusable envelope"],
    rating: 4.9,
    reviews: 71,
    collection: "restock",
    stock: 34,
  },
  {
    id: 8,
    name: "Perpetual Date Stamp",
    brand: "Atelier Sunday",
    category: "Stamps",
    price: 179,
    image: "/img/08-date-stamp.jpg",
    images: ["/img/08-date-stamp.jpg"],
    description:
      "A compact wooden date stamp with clean, endlessly useful numerals for planners, reading logs and correspondence.",
    attributes: { Impression: "28 × 5 mm", Range: "2024–2035", Handle: "Beech wood", Ink: "Not included" },
    tags: ["stamp", "date", "planner", "new"],
    size: ["28 mm"],
    colors: ["Natural"],
    features: ["Smooth rotating bands", "Fine rubber impression", "Plastic-free paper box"],
    rating: 4.8,
    reviews: 22,
    collection: "new",
    stock: 14,
  },
  {
    id: 9,
    name: "Pocket Herb Stamp Quartet",
    brand: "Atelier Sunday",
    category: "Stamps",
    price: 139,
    image: "/img/09-herb-stamp.jpg",
    images: ["/img/09-herb-stamp.jpg"],
    description:
      "Four tiny botanical rubber stamps—sprig, seed, leaf and bloom—drawn to combine into your own repeating borders.",
    attributes: { Pieces: "4", Impression: "12–18 mm", Handle: "Maple wood", Rubber: "Red rubber" },
    tags: ["stamp", "botanical", "set", "restock"],
    size: ["Set of 4"],
    colors: ["Natural"],
    features: ["Crisp fine-line carving", "Mix-and-match motifs", "Cotton storage pouch"],
    rating: 4.7,
    reviews: 36,
    collection: "restock",
    stock: 16,
  },
  {
    id: 10,
    name: "Crescent Brass Stamp",
    brand: "Atelier Sunday",
    category: "Stamps",
    price: 175,
    compareAtPrice: 180,
    image: "/img/10-moon-stamp.jpg",
    images: ["/img/10-moon-stamp.jpg"],
    description:
      "A weighty brass-handled stamp that leaves a slender crescent mark—simple enough for margins, envelopes and moon-phase trackers.",
    attributes: { Impression: "18 mm", Handle: "Solid brass", Base: "Engraved rubber", Ink: "Not included" },
    tags: ["stamp", "moon", "brass", "limited", "sale"],
    size: ["18 mm"],
    colors: ["Aged Brass"],
    features: ["Balanced tactile handle", "Fine crescent line", "Limited workshop run"],
    rating: 4.9,
    reviews: 18,
    collection: "limited",
    stock: 6,
  },
  {
    id: 11,
    name: "Night Tide Fountain Pen",
    brand: "Kumo Works",
    category: "Writing & Drawing",
    price: 179,
    image: "/img/11-fountain-pen.jpg",
    images: ["/img/11-fountain-pen.jpg"],
    description:
      "A balanced everyday fountain pen in deep ocean blue with a smooth steel nib and a gently faceted cap that stays put on the desk.",
    attributes: { Nib: "Fine steel", Fill: "Converter or cartridge", Body: "Resin", Length: "137 mm" },
    tags: ["pen", "fountain pen", "blue", "new"],
    size: ["Fine nib"],
    colors: ["Night Tide", "Mist"],
    features: ["Snap cap with inner seal", "Converter included", "Comfortable low step"],
    rating: 4.8,
    reviews: 43,
    collection: "new",
    stock: 19,
  },
  {
    id: 12,
    name: "Soft Tone Gel Pen Set",
    brand: "Kumo Works",
    category: "Writing & Drawing",
    price: 109,
    image: "/img/12-gel-pens.jpg",
    images: ["/img/12-gel-pens.jpg"],
    description:
      "Five fine gel pens in softened daily colours, selected to annotate without overwhelming the page.",
    attributes: { Tip: "0.5 mm", Ink: "Water-based pigment gel", Pieces: "5", Grip: "Soft elastomer" },
    tags: ["gel pen", "set", "muted colour", "restock"],
    size: ["0.5 mm"],
    colors: ["Soft Tone Set"],
    features: ["Quick-drying ink", "Consistent fine line", "Refillable barrels"],
    rating: 4.7,
    reviews: 88,
    collection: "restock",
    stock: 37,
  },
  {
    id: 13,
    name: "Quiet Brush Pen Trio",
    brand: "Kumo Works",
    category: "Writing & Drawing",
    price: 119,
    compareAtPrice: 149,
    image: "/img/13-brush-pens.jpg",
    images: ["/img/13-brush-pens.jpg"],
    description:
      "Three dual-tip brush pens with a flexible fibre brush and a precise fineliner, tuned for compact lettering and soft shadow accents.",
    attributes: { Tips: "Brush + 0.5 mm", Ink: "Water-based dye", Pieces: "3", Body: "Recycled PP" },
    tags: ["brush pen", "lettering", "dual tip", "sale"],
    size: ["Set of 3"],
    colors: ["Earth Set"],
    features: ["Flexible controlled brush", "Colour-matched fineliner", "Ventilated click caps"],
    rating: 4.6,
    reviews: 34,
    collection: "limited",
    stock: 12,
  },
  {
    id: 14,
    name: "Cedar Graphite Pencil Set",
    brand: "Kumo Works",
    category: "Writing & Drawing",
    price: 95,
    image: "/img/14-pencil-set.jpg",
    images: ["/img/14-pencil-set.jpg"],
    description:
      "Six cedar pencils spanning everyday writing to expressive sketching, finished with a tactile clear coat that lets the wood show through.",
    attributes: { Grades: "2H, H, HB, B, 2B, 4B", Wood: "Incense cedar", Shape: "Hexagonal", Pieces: "6" },
    tags: ["pencil", "graphite", "drawing", "new"],
    size: ["Set of 6"],
    colors: ["Natural"],
    features: ["Smooth centered cores", "Easy sharpening cedar", "FSC-certified paper sleeve"],
    rating: 4.8,
    reviews: 29,
    collection: "new",
    stock: 28,
  },
  {
    id: 15,
    name: "Ochre Field Notes",
    brand: "Hush Paper Studio",
    category: "Notebooks & Journals",
    price: 49,
    image: "/img/15-pocket-notebook.jpg",
    images: ["/img/15-pocket-notebook.jpg"],
    description:
      "A slim pocket notebook with a sturdy ochre cover and unobtrusive grey ruling, built to travel in a coat pocket or pencil case.",
    attributes: { Size: "90 × 140 mm", Pages: "64 ruled pages", Cover: "Uncoated card", Paper: "80 gsm" },
    tags: ["notebook", "pocket", "ruled", "restock"],
    size: ["Pocket"],
    colors: ["Ochre", "Brick"],
    features: ["Stitched binding", "Rounded corners", "Light grey 6 mm ruling"],
    rating: 4.6,
    reviews: 47,
    collection: "restock",
    stock: 45,
  },
  {
    id: 16,
    name: "Blue Hour Soft-Ring Notebook",
    brand: "Hush Paper Studio",
    category: "Notebooks & Journals",
    price: 119,
    image: "/img/16-ring-notebook.jpg",
    images: ["/img/16-ring-notebook.jpg"],
    description:
      "A calm blue notebook with flexible rings that compress comfortably beneath your hand while writing from edge to edge.",
    attributes: { Format: "B6", Pages: "120 grid pages", Binding: "Soft polymer ring", Paper: "90 gsm" },
    tags: ["notebook", "soft ring", "grid", "new"],
    size: ["B6"],
    colors: ["Blue Hour", "Cloud"],
    features: ["Low-profile flexible rings", "Micro-perforated pages", "Durable matte cover"],
    rating: 4.8,
    reviews: 41,
    collection: "new",
    stock: 23,
  },
  {
    id: 17,
    name: "Terracotta Daily Planner",
    brand: "Hush Paper Studio",
    category: "Notebooks & Journals",
    price: 149,
    image: "/img/17-daily-planner.jpg",
    images: ["/img/17-daily-planner.jpg"],
    description:
      "An undated daily planner with just enough structure: priorities, a quiet timeline and open space for notes, all wrapped in warm terracotta cloth.",
    attributes: { Format: "A5", Layout: "192 undated daily pages", Cover: "Book cloth", Paper: "100 gsm" },
    tags: ["planner", "undated", "daily", "limited"],
    size: ["A5"],
    colors: ["Terracotta"],
    features: ["Undated start-anytime format", "Lay-flat binding", "Two ribbon markers"],
    rating: 4.9,
    reviews: 55,
    collection: "limited",
    stock: 11,
  },
  {
    id: 18,
    name: "Morning Letter Set",
    brand: "Nami Press",
    category: "Paper Goods",
    price: 79,
    image: "/img/18-letter-set.jpg",
    images: ["/img/18-letter-set.jpg"],
    description:
      "A gentle correspondence set with deckled-look sheets, softly lined writing guides and envelopes in warm natural tones.",
    attributes: { Sheets: "12", Envelopes: "6", Paper: "90 gsm laid paper", Size: "A5 folded" },
    tags: ["letter", "envelope", "paper", "new"],
    size: ["6 letters"],
    colors: ["Morning Cream"],
    features: ["Removable writing guide", "Water-activated envelope gum", "Recycled paper belly band"],
    rating: 4.7,
    reviews: 24,
    collection: "new",
    stock: 25,
  },
  {
    id: 19,
    name: "Small Seasons Postcard Set",
    brand: "Nami Press",
    category: "Paper Goods",
    price: 89,
    image: "/img/19-postcard-set.jpg",
    images: ["/img/19-postcard-set.jpg"],
    description:
      "Four original art postcards that notice small seasonal shifts—early light, new leaves, long evenings and the first cool air.",
    attributes: { Cards: "4 designs", Size: "A6", Stock: "350 gsm", Print: "Plant-based inks" },
    tags: ["postcard", "art print", "seasonal", "limited"],
    size: ["Set of 4"],
    colors: ["Four Seasons"],
    features: ["Blank address side", "Uncoated writing surface", "Original abstract artwork"],
    rating: 4.8,
    reviews: 20,
    collection: "limited",
    stock: 13,
  },
  {
    id: 20,
    name: "Cream Pocket Craft Scissors",
    brand: "Tocoro Atelier",
    category: "Desk Essentials",
    price: 129,
    image: "/img/20-craft-scissors.jpg",
    images: ["/img/20-craft-scissors.jpg"],
    description:
      "Compact craft scissors with a reassuring slide cover and fine stainless blades for tape, paper and delicate collage work.",
    attributes: { Length: "105 mm", Blade: "Stainless steel", Handle: "ABS resin", Cover: "Slide-lock" },
    tags: ["scissors", "desk tool", "collage", "restock"],
    size: ["Pocket"],
    colors: ["Cream", "Sage"],
    features: ["Fine pointed blade", "Secure travel cover", "Comfortable rounded grip"],
    rating: 4.7,
    reviews: 63,
    collection: "restock",
    stock: 30,
  },
  {
    id: 21,
    name: "Brass Page Clip Trio",
    brand: "Tocoro Atelier",
    category: "Desk Essentials",
    price: 75,
    image: "/img/21-brass-clip.jpg",
    images: ["/img/21-brass-clip.jpg"],
    description:
      "Three slender brass clips that hold a planner open, mark a reference page or keep a small stack of letters together.",
    attributes: { Pieces: "3", Length: "35 mm", Material: "Brushed brass", Capacity: "20 sheets" },
    tags: ["clip", "brass", "bookmark", "new"],
    size: ["Set of 3"],
    colors: ["Brass"],
    features: ["Low-profile spring", "Rounded paper-safe edges", "Develops a natural patina"],
    rating: 4.6,
    reviews: 33,
    collection: "new",
    stock: 38,
  },
  {
    id: 22,
    name: "Olive Canvas Pencil Case",
    brand: "Fieldwork Objects",
    category: "Carriers & Accessories",
    price: 169,
    compareAtPrice: 180,
    image: "/img/22-pencil-case.jpg",
    images: ["/img/22-pencil-case.jpg"],
    description:
      "A slim washed-canvas case with room for the handful of tools you actually use, finished with a smooth metal zip and cotton lining.",
    attributes: { Size: "195 × 65 × 35 mm", Outer: "Washed cotton canvas", Lining: "Cotton", Closure: "Metal zip" },
    tags: ["pencil case", "canvas", "storage", "sale"],
    size: ["Slim"],
    colors: ["Olive", "Natural"],
    features: ["Holds up to 12 pens", "Internal eraser pocket", "Machine-washable cold"],
    rating: 4.8,
    reviews: 46,
    collection: "limited",
    stock: 10,
  },
  {
    id: 23,
    name: "Meadow Window Bookmark",
    brand: "Nami Press",
    category: "Paper Goods",
    price: 45,
    image: "/img/23-bookmark.jpg",
    images: ["/img/23-bookmark.jpg"],
    description:
      "A translucent bookmark framing an original pressed-meadow composition, thin enough to disappear between pages while the artwork peeks above.",
    attributes: { Size: "45 × 145 mm", Material: "Translucent recycled PET", Thickness: "0.3 mm", Finish: "Frosted" },
    tags: ["bookmark", "botanical", "transparent", "restock"],
    size: ["Standard"],
    colors: ["Meadow"],
    features: ["Rounded corners", "Light-catching frosted finish", "Original botanical composition"],
    rating: 4.7,
    reviews: 58,
    collection: "restock",
    stock: 40,
  },
  {
    id: 24,
    name: "Smoke Stencil Ruler",
    brand: "Tocoro Atelier",
    category: "Desk Essentials",
    price: 99,
    image: "/img/24-stencil-ruler.jpg",
    images: ["/img/24-stencil-ruler.jpg"],
    description:
      "A transparent smoky ruler combining a precise 15-centimetre edge with understated planning symbols and small geometric templates.",
    attributes: { Length: "160 mm", Scale: "15 cm", Material: "Recycled acrylic", Templates: "18 symbols" },
    tags: ["ruler", "stencil", "planner", "new"],
    size: ["15 cm"],
    colors: ["Smoke"],
    features: ["Fine etched scale", "Non-slip dotted edge", "Compact planner-friendly size"],
    rating: 4.8,
    reviews: 37,
    collection: "new",
    stock: 29,
  },
  {
    id: 25,
    name: "Lattice Desk Organizer",
    brand: "Purelattice Studio",
    category: "Desk Essentials",
    price: 118,
    image: "/img/25-desk-organizer.jpg",
    images: ["/img/25-desk-organizer.jpg"],
    description:
      "A compact powder-coated steel organizer with an open lattice frame for pens, notes and the small tools that keep a desk moving.",
    attributes: { Size: "180 × 95 × 105 mm", Material: "Powder-coated steel", Compartments: "4", Base: "Cork-lined" },
    tags: ["organizer", "desk", "storage", "new"],
    size: ["Desktop"],
    colors: ["Warm White", "Sage"],
    features: ["Four practical sections", "Non-slip cork base", "Rounded powder-coated edges"],
    rating: 4.8,
    reviews: 19,
    collection: "new",
    stock: 22,
  },
];

export const productCategories = [...new Set(productData.map((product) => product.category))];

export default productData;
